import React, { useState, useEffect } from 'react';
import { fetchCategories } from '../services/api';
import { toast } from 'react-toastify';

const MiddleCategoryFilter = ({ onFilterChange, initialFilters = {} }) => {
  const [categoryName, setCategoryName] = useState(initialFilters.categoryName || 'Arts');
  const [categories, setCategories] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  // Fetch categories on component mount
  useEffect(() => {
    const loadCategories = async () => {
      setIsLoading(true);
      try {
        const data = await fetchCategories();
        setCategories(data);
        
        // If no initial filter is set, default to Arts
        if (!initialFilters.categoryName) {
          // Find Arts category and trigger initial filter
          const artsCategory = data.find(cat => cat.name === 'Arts');
          if (artsCategory) {
            onFilterChange({ categoryName: 'Arts' });
          }
        }
      } catch (error) {
        toast.error('Failed to load categories');
        console.error('Error loading categories:', error);
      } finally {
        setIsLoading(false);
      }
    };

    loadCategories();
  }, []);

  const handleCategoryChange = (newCategoryName) => {
    setCategoryName(newCategoryName);
    onFilterChange({ categoryName: newCategoryName });
  };

  const handleResetFilters = () => {
    setCategoryName('Arts');
    onFilterChange({ categoryName: 'Arts' });
  };

  return (
    <div className="bg-white p-4 mb-4 rounded-lg shadow">
      <div className="flex flex-col space-y-4">
        <div>
          <label htmlFor="category" className="block text-sm font-medium text-gray-700 mb-1">
            Filter by Category
          </label>
          <select
            id="category"
            value={categoryName}
            onChange={(e) => handleCategoryChange(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 min-h-[44px]"
            disabled={isLoading}
          >
            {categories.map((category) => (
              <option key={category.id} value={category.name}>
                {category.name}
              </option>
            ))}
          </select>
        </div>
        
        <div className="flex flex-wrap gap-2">
          <button
            onClick={handleResetFilters}
            className="px-4 py-2 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 min-h-[44px] flex-1 md:flex-none"
          >
            Reset to Arts
          </button>
        </div>
      </div>
    </div>
  );
};

export default MiddleCategoryFilter;

